import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { Observable, Subject, of } from 'rxjs';
import { finalize } from 'rxjs/operators';
import {
  DynamicFormDesignerConfig,
  DynamicFormDataModel,
  DynamicFormUpdateDataModel
} from 'zr-dynamic-form/dynamic-form-designer';
import { FormContentResponse } from 'zr-dynamic-form/dynamic-form-common';

@Injectable({ providedIn: 'root' })
export class FormDataService {
  private formNames: Map<string, string> = new Map<string, string>();
  private serviceUrl = '//';
  constructor(designConfig: DynamicFormDesignerConfig, private http: HttpClient) {
    // this.http = this.skipErrorClient();
    this.serviceUrl = designConfig.serviceUrl;
  }

  // Get formContent(code)
  getFormContent(formCode: string, labelCode?: string): Observable<FormContentResponse> {
    const url = `${this.getFormDataUrl()}/published/content`;
    return this.http.get<FormContentResponse>(url, { params: { formCode: formCode, labelCode: labelCode } });
  }

  getFormName(formCode: string, labelCode?: string): Observable<string> {
    const sub = new Subject<string>();
    const url = `${this.getFormDataUrl()}/published/name`;
    this.http
      .get(url, { params: { formCode: formCode, labelCode: labelCode } })
      .pipe(
        finalize(() => {
          sub.complete();
        })
      )
      .subscribe(
        (s: any) => {
          const name = s.data;
          sub.next(name);
        },
        (error) => sub.error(error)
      );
    return sub.asObservable();
  }

  setFormNameCache(formCodeKeyKey: string, formName: string) {
    this.formNames.set(formCodeKeyKey, formName);
  }

  detail(formCode: string, targetId: string): Observable<any> {
    const url = `${this.getFormDataUrl()}/detail`;
    return this.http.get(url, { params: { formCode: formCode, targetId: targetId } });
  }

  add(context: DynamicFormDataModel): Observable<any> {
    const url = `${this.getFormDataUrl()}`;
    return this.http.post(url, context);
  }

  update(context: DynamicFormUpdateDataModel): Observable<any> {
    const url = `${this.getFormDataUrl()}`;
    return this.http.put(url, context);
  }

  delete(formCode: string, targetId: string): Observable<any> {
    const url = `${this.getFormDataUrl()}`;
    return this.http.delete(url, { params: { formCode: formCode, targetId: targetId } });
  }

  deletePatch(formCode: string, targetIds: string[]): Observable<any> {
    const url = `${this.getFormDataUrl()}/batch`;
    return this.http.delete(url, { params: { formCode: formCode, targetIds: targetIds } });
  }

  getUnionForms(params: HttpParams): Observable<any> {
    const url = `${this.getFormDataUrl()}/union`;
    return this.http.get(url, { params: params });
  }

  private getFormDataUrl() {
    return `${this.serviceUrl}dynamicform/formdatas`;
  }

  private skipErrorClient(): HttpClient {
    // å»ælunz+ æ¡æ¶ä¸­çéè¯¯è¿æ»¤
    const skipErrorHandlerName = 'skipErrorHandler';
    if (typeof this.http[skipErrorHandlerName] === 'function') {
      const client = this.http[skipErrorHandlerName]();
      return client;
    }
    return this.http;
  }
}
